import { useEffect } from "react";
import { Modal, Textarea, Button, Group, Rating, Stack, ActionIcon } from "@mantine/core";
import { IconTrash } from "@tabler/icons-react";
import { useForm } from "@mantine/form";

const ModalRatingAndText = ({
  opened,
  onClose,
  onSave,
  onDelete,
  initialValues = { Id: null, puntuacion: 0, comentarios: "" },
  title = "Valoración",
  saveLabel = "Guardar",
  deleteLabel = "Eliminar",
  saveLoading = false,
  deleteLoading = false,
}) => {
  const form = useForm({
    initialValues,
    validate: {
      puntuacion: (value) => (value > 0 ? null : "Debe al menos  una valoración"),
    },
  });

  useEffect(() => {
    form.setValues(initialValues);
  }, [initialValues]);

  useEffect(() => {
    if (!opened) form.reset();
  }, [opened]);

  const handleSubmit = () => {
    const validation = form.validate();
    if (!validation.hasErrors) {
      onSave(form.values);
    }
  };

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={title}
      centered
      size="450px"
      closeOnClickOutside={false}
    >
      <Stack align="stretch" gap="xs">
        <Group justify="center">
          <Rating
            size={45}
            count={4}
            {...form.getInputProps("puntuacion")}
            disabled={saveLoading || deleteLoading}
          />
        </Group>
        <Textarea
          label="Comentarios"
          mt="md"
          disabled={saveLoading || deleteLoading}
          autosize
          minRows={4}
          maxRows={8}
          {...form.getInputProps("comentarios")}
        />
        <Group wrap="nowrap" spacing="xs" mt="md">
          {onDelete && form.values.Id && (
            <ActionIcon
              onClick={() => onDelete(form.values.Id)}
              loading={deleteLoading}
              disabled={saveLoading}
              color="grey"
              size="lg"
              title={deleteLabel}
            >
              <IconTrash size={18} />
            </ActionIcon>
          )}
          <Button
            fullWidth
            color="#e91e63"
            onClick={() => handleSubmit()}
            loading={saveLoading}
            disabled={deleteLoading}
          >
            {saveLabel}
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};

export default ModalRatingAndText;